import { api } from '@api'
import { UpdateDriverData } from '@types'

interface UpdateDriverResponse {
  message: string
}

const updateDriver = async (driverId: number, data: UpdateDriverData) => {
  const driverData = {
    driver: {
      phone: data.phone,
      disabled: data.disabled,
      ...(!!data.preferredTruck && { preferredTruck: { id: data.preferredTruck } }),
      ...(!!data.preferredTrailer && { preferredTrailer: { id: data.preferredTrailer } }),
    },
  }
  const response = await api.put<UpdateDriverResponse>(`/drivers/${driverId}`, driverData)

  return response.data.message
}

export const DriversApi = {
  updateDriver,
}

// TODO: Multicarriers Advances
